import React from 'react';
import { 
    Table, TableBody, TableCell, TableContainer, TableHead, 
    TableRow, Button, IconButton, Stack, Typography, 
    Box, Tooltip, Card, CardHeader, CardContent
} from '@mui/material';
import { 
    FaPlus, FaArrowUp, FaArrowDown, FaEdit, 
    FaLink, FaListOl, FaWrench 
} from 'react-icons/fa';

const BoardMemberManagement = ({ 
    members, 
    onAdd, 
    onEdit, 
    onDelete, 
    onMove, 
    getDisplayName 
}) => {
    return (
        <Card elevation={1} sx={{ mb: 4, borderRadius: 2, overflow: 'hidden' }}>
            <CardHeader 
                title={
                    <Typography variant="subtitle1" fontWeight="bold">Vorstandsteam</Typography>
                }
                action={
                    <Button 
                        variant="contained" 
                        size="small" 
                        startIcon={<FaPlus />} 
                        onClick={onAdd}
                        sx={{ bgcolor: 'error.main', '&:hover': { bgcolor: 'error.dark' } }}
                    >
                        Neu
                    </Button>
                }
                sx={{ bgcolor: 'white', borderBottom: '1px solid #f0f0f0' }}
            />
            <CardContent sx={{ p: 0 }}>
                <TableContainer sx={{ overflowAnchor: 'none' }}>
                    <Table size="small">
                        <TableHead sx={{ bgcolor: '#f8f9fa' }}>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.75rem' }}>NAME</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.75rem', display: { xs: 'none', md: 'table-cell' } }}>POSITION</TableCell>
                                <TableCell align="center" sx={{ width: '1%', fontWeight: 'bold', fontSize: '0.75rem' }}><FaListOl /></TableCell>
                                <TableCell align="center" sx={{ width: '1%', fontWeight: 'bold', fontSize: '0.75rem' }}><FaWrench /></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {members.map((m, idx) => (
                                <TableRow key={m._id || idx} hover>
                                    <TableCell>
                                        <Stack direction="row" spacing={1.5} alignItems="center">
                                            <Stack direction="row" sx={{ flexShrink: 0 }}>
                                                <IconButton 
                                                    size="small" 
                                                    disabled={idx === 0} 
                                                    onClick={() => onMove(idx, -1)}
                                                    sx={{ p: 0.5 }}
                                                >
                                                    <FaArrowUp fontSize="0.7rem" />
                                                </IconButton>
                                                <IconButton 
                                                    size="small" 
                                                    disabled={idx === members.length - 1} 
                                                    onClick={() => onMove(idx, 1)}
                                                    sx={{ p: 0.5 }}
                                                >
                                                    <FaArrowDown fontSize="0.7rem" />
                                                </IconButton>
                                            </Stack>
                                            <Box>
                                                <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>
                                                    {getDisplayName(m)}
                                                    {m.playerId && (
                                                        <Tooltip title="Mit Spielerprofil verknüpft">
                                                            <Box component="span" sx={{ ml: 1 }}>
                                                                <FaLink fontSize="0.75rem" color="#17a2b8" />
                                                            </Box>
                                                        </Tooltip>
                                                    )}
                                                </Typography>
                                            </Box>
                                        </Stack>
                                    </TableCell>
                                    <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>
                                        <Box 
                                            component="span" 
                                            sx={{ 
                                                fontSize: '0.7rem', 
                                                px: 1, py: 0.25, 
                                                bgcolor: '#f1f3f5', 
                                                borderRadius: 1,
                                                color: '#495057',
                                                fontWeight: 'medium'
                                            }}
                                        >
                                            {m.position}
                                        </Box>
                                    </TableCell>
                                    <TableCell align="center">
                                        <Typography variant="caption" color="text.secondary">{m.order}</Typography>
                                    </TableCell>
                                    <TableCell align="center">
                                        <IconButton size="small" color="primary" onClick={() => onEdit(m)}>
                                            <FaEdit fontSize="0.9rem" />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </CardContent>
        </Card>
    );
};

export default BoardMemberManagement;
